import React, { useState, useEffect } from 'react';
import './FeedbackDrawer.css';

const FeedbackDrawer = ({ isOpen, messageId, currentRating, onClose, onSubmit }) => {
    const [rating, setRating] = useState(currentRating || 0);
    const [comment, setComment] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setRating(currentRating || 0);
            setComment('');
        }
    }, [isOpen, currentRating]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (rating === 0) {
            alert('Please select a rating');
            return;
        }

        setIsSubmitting(true);        
        await onSubmit(messageId, rating, comment.trim() || null);
        setIsSubmitting(false);
        onClose();
    };

    const getRatingLabel = (num) => {
        if (num === 0) return 'Select a rating';
        if (num <= 2) return 'Very Poor';
        if (num <= 4) return 'Poor';
        if (num <= 6) return 'Average';
        if (num <= 8) return 'Good';
        return 'Excellent!';
    };

    if (!isOpen) return null;

    return (
        <>
            <div className="drawer-overlay" onClick={onClose} />
            <div className={`feedback-drawer ${isOpen ? 'open' : ''}`}>
                <div className="drawer-header">
                    <h3>Rate this response</h3>
                    <button type="button" className="close-btn" onClick={onClose}>×</button>
                </div>

                <form onSubmit={handleSubmit} className="drawer-content">
                    <div className="rating-section">
                        <label>How would you rate this response?</label>
                        <div className="number-rating">
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(num => (
                                <button
                                    key={num}
                                    type="button"
                                    className={`number-btn ${num === rating ? 'selected' : ''}`}
                                    onClick={() => setRating(num)}
                                >
                                    {num}
                                </button>
                            ))}
                        </div>
                        <div className="rating-labels">
                            <span className="label-left">Poor</span>
                            <span className="label-center">{getRatingLabel(rating)}</span>
                            <span className="label-right">Excellent</span>
                        </div>
                    </div>

                    <div className="comment-section">
                        <label htmlFor="feedback-comment">
                            Additional feedback <span className="optional">(optional)</span>
                        </label>
                        <textarea
                            id="feedback-comment"
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            placeholder="Tell us more about your experience..."
                            rows={4}
                            maxLength={500}
                        />
                        <span className="char-count">{comment.length}/500</span>
                    </div>

                    <div className="drawer-actions">
                        <button type="button" className="btn-cancel" onClick={onClose}>
                            Cancel
                        </button>
                        <button 
                            type="submit" 
                            className="btn-submit" 
                            disabled={rating === 0 || isSubmitting}
                        >
                            {isSubmitting ? 'Submitting...' : 'Submit Feedback'}
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default FeedbackDrawer;